import { Spin, Space } from "antd";

const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      }}
    >
      <Space direction="vertical" style={{ textAlign: "center" }}>
        <Spin
          size="large"
          indicator={
            <svg
              viewBox="0 0 64 64"
              style={{
                width: "2em",
                height: "2em",
                animation: "spin 1s infinite linear",
                color: "#936f42",
              }}
            >
              <path
                d="M32 12a20 20 0 1 0 20 20"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          }
        />
        <div
          style={{
            color: "#936f42",
            fontSize: 16,
            marginTop: 12,
          }}
        >
          页面加载中...
        </div>
      </Space>
    </div>
  );
};

export default Loading;
